<template>
  <van-form @submit="onSubmit" label-width="100px" :readonly="!isAdd">
    <van-field label="单号" v-model="record.bailmentNo" readonly v-if="!isAdd"/>
    <van-field label="寄托人姓名" @change="$forceUpdate()" placeholder="（必填）" :maxlength="32" v-model="record.name" :rules="[{ required: true, message: '请输入寄托人' }]"/>
    <van-field label="工号/学号" @change="$forceUpdate()" placeholder="（必填）" :maxlength="100" v-model="record.jdUserCode" :rules="[{ required: true, message: '请输入工号/学号' }]"/>
    <van-field label="寄托物品" placeholder="（必填）" :maxlength="100" v-model="record.goodsName" :rules="[{ required: true, message: '请输入寄托物品' }]"/>
    <van-field label="放置位置" placeholder="（必填）" :maxlength="100" v-model="record.place" :rules="[{ required: true, message: '请输入放置位置' }]"/>
    <van-field label="放置位置图片" input-align="right">
      <template #input>
        <van-uploader :after-read="afterRead" v-model="fileList" :max-count="1" @delete="delPic"/>
      </template>
    </van-field>
    <van-field
        readonly
        clickable
        name="datetimePicker"
        v-model="record.placeTime"
        label="放置时间"
        @click="changePicker('showPicker')"
    />
    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker
          type="datetime"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="pickerConfirm($event, 'placeTime', 'showPicker')"
          @cancel="closePicker('showPicker')"
      />
    </van-popup>
    <van-field label="外部取件人姓名" :maxlength="32" v-model="record.pecipientName" />
    <van-field label="手机号码" placeholder="（必填）" :maxlength="32" v-model="record.pecipientMobileNum" :rules="[{ required: true, message: '请输入手机号码' }]"/>
    <van-field label="车牌号" :maxlength="50" v-model="record.licence" />
    <van-field label="所属单位" :maxlength="100" v-model="record.unit" />
    <van-field
        readonly
        clickable
        v-model="record.strTime"
        label="预计取件开始时间"
        placeholder="（必填）"
        @click="changePicker('showPicker2')"
        :rules="[{ required: true, message: '请选择' }]"
    />
    <van-popup v-model="showPicker2" position="bottom">
      <van-datetime-picker
          type="datetime"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="pickerConfirm($event, 'strTime', 'showPicker2')"
          @cancel="closePicker('showPicker2')"
      />
    </van-popup>
    <van-field
        readonly
        clickable
        v-model="record.endTime"
        label="预计取件结束时间"
        placeholder="（必填）"
        @click="changePicker('showPicker3')"
        :rules="[{ required: true, message: '请选择' }]"
    />
    <van-popup v-model="showPicker3" position="bottom">
      <van-datetime-picker
          type="datetime"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="pickerConfirm($event, 'endTime', 'showPicker3')"
          @cancel="closePicker('showPicker3')"
      />
    </van-popup>
    <van-field
        v-model="record.remark"
        label="备注"
        type="textarea"
        :maxlength="200"
        :rows="4"
    />

    <div class="b-but">
      <van-button v-if="isAdd" block :loading="loading" type="info" native-type="submit">提交</van-button>
      <van-button v-else @click.stop="$router.go(-1)">返回</van-button>
    </div>
  </van-form>
</template>

<script>
import moment from "moment";
import {get, add} from '@/api/entrust/entrust'
import {getUserInfo} from "@/api/my/my";
import {customUploadFile, FILE_DISPLAY_PREFIX} from "@/api/upload";

export default {
  name: "detail",
  data() {
    return {
      filePrefix: FILE_DISPLAY_PREFIX,
      fileList: [],
      showPicker: false,
      showPicker2: false,
      showPicker3: false,
      minDate: moment().add(-6, 'month').toDate(),
      maxDate: moment().add(6, 'month').toDate(),
      loading: false,
      user: {},
      record: {},
      id: ''
    }
  },
  computed: {
    isAdd () {
      return !this.id
    }
  },
  created() {
    this.id = this.$route.query.id
    if (!this.isAdd) {
      get(this.id).then(res => {
        if (res.code === 10000) {
          this.record = res.result || {}
          this.fileList.push({url: this.filePrefix + this.record.placePic})
        }
      })
    } else {
      this.getUserInfo()
    }
  },
  methods: {
    getUserInfo() {
      getUserInfo().then(res => {
        if (res.code === 10000) {
          this.user = res.result || {}
          this.record.name = this.user.fullName
          if (this.user.studentInfo) {
            this.record.jdUserCode = this.user.studentInfo.studentCode
          } else if (this.user.teacherInfo) {
            this.record.jdUserCode = this.user.teacherInfo.teacherCode
          }
          this.$forceUpdate()
        }
      })
    },
    onSubmit() {
      if (!this.isAdd) {
        return
      }
      this.loading = true;
      const data = {
        ...this.record
      };
      add(data).then(res => {
        if (res.code === 10000) {
          this.$toast("保存成功！");
          setTimeout(() => {
            this.$router.go(-1)
          }, 200)
        }
      }).finally(() => {
        setTimeout(() => {
          this.loading = false
        }, 200)
      });
    },
    back() {
      this.$router.go(-1)
    },
    // eslint-disable-next-line no-unused-vars
    delPic(file) {
      this.record.placePic = ''
    },
    afterRead(file) {
      customUploadFile(file).then(res => {
        if (res.code === 10000) {
          this.record.placePic = res.result[0]
          this.fileList.push({
            url: this.filePrefix + res.result[0],
            path: res.result[0]
          })
        }
      }).catch(e => {
        this.$toast('上传失败' + e)
      }).finally(() => {
        this.fileList = this.fileList.filter(i => i.url)
      })
    },
    pickerConfirm(time, k, k2) {
      this.record[k] = moment(time).format('YYYY-MM-DD HH:mm:ss');
      this[k2] = false;
    },
    changePicker(k) {
      if (this.isAdd) {
        this[k] = true
      }
    },
    closePicker(k) {
      this[k] = false
    }
  }
}
</script>

<style scoped>

</style>
